module.exports = __webpack_public_path__ + "static/img/fee.9625c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/fee.png
// module id = kDhZ
// module chunks = 4